'use client';

import { useEffect } from 'react';
import { useUser, useClerk } from '@clerk/nextjs';

const HomeAuthButton = () => {
  const { user } = useUser();
  const { openSignIn } = useClerk();

  const redirectToDashboard = (role: string) => {
    const dashboardPaths: Record<string, string> = {
      admin: '/admin',
      formator: '/admin',
      media: '/list/news',
      lecturer: '/lecturer',
      seminarian: '/seminarian',
    };

    window.location.href = dashboardPaths[role] || '/';
  };

  const handleClick = () => {
    if (user) {
      const role = user.publicMetadata?.role as string || '';
      redirectToDashboard(role);
    } else {
      window.location.href = '/login';
    }
  };

  return (
    <>
      <button className="home-hero-btn" onClick={handleClick}>
        {user ? 'DASHBOARD' : 'LOG IN'}
      </button>
    </>
  );
};

export default HomeAuthButton;